import Vue from 'vue'
import VueRouter from 'vue-router'
import sections from '@/navigation/sections'

Vue.use(VueRouter)

// Every page knows its section and tab (navigation/sections.js): the side menu keeps the section
// highlighted on all its tabs (meta.navActiveLink), and SectionTabs shows the section's tabs.
function tag(routes) {
  routes.forEach(function (r) {
    sections.forEach(function (s) {
      s.tabs.forEach(function (t) {
        if (t.route && (t.route == r.name || (t.also || []).includes(r.name))) {
          r.meta = Object.assign({}, r.meta, { section: s.key, tab: t.route, navActiveLink: s.tabs.find(function (x) { return x.route }).route })
        }
      })
    })
  })
  return routes
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: tag([
    {
      path: '/enjazfile/users',
      name: 'enjazfile/users',
      component: () => import('@/views/enjazfile/users.vue')
    },
    {
      path: '/enjazfile/orders',
      name: 'enjazfile/orders',
      component: () => import('@/views/enjazfile/orders.vue')
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/posts',
      name: 'posts',
      component: () => import('@/views/posts.vue')
    },
    {
      path: '/feedback/type/feedback',
      name: 'feedback1',
      component: () => import('@/views/feedbacks.vue')
    },
    {
      path: '/ticket/:id',
      name: 'ticket',
      component: () => import('@/views/ticket.vue')
    },
    {
      path: '/feedback/type/ticket',
      name: 'feedback2',
      component: () => import('@/views/feedbacks.vue')
    },
    {
      path: '/calls',
      name: 'calls',
      component: () => import('@/views/calls.vue')
    },
    {
      path: '/new-year',
      name: 'new-year',
      component: () => import('@/views/new-year.vue')
    },
    {
      path: '/ups',
      name: 'ups',
      component: () => import('@/views/ups.vue')
    },
    {
      path: '/support',
      name: 'support',
      component: () => import('@/views/support.vue')
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/views/users.vue')
    },
    {
      path: '/resellers',
      name: 'resellers',
      component: () => import('@/views/resellers.vue')
    },
    {
      // the old devices page is replaced by «اجهزة البصمة الجميلة» (views/biotime.vue); keep old links working
      path: '/devices',
      name: 'devices',
      redirect: to => ({ path: '/biotime', hash: to.hash })
    },
    {
      path: '/biotime',
      name: 'biotime',
      component: () => import('@/views/biotime.vue')
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/settings.vue')
    },
    {
      path: '/app-versions',
      name: 'app-versions',
      component: () => import('@/views/app-versions.vue')
    },
    {
      path: '/app-messages',
      name: 'app-messages',
      component: () => import('@/views/app-messages.vue')
    },
    {
      path: '/app-push',
      name: 'app-push',
      component: () => import('@/views/app-push.vue')
    },
    {
      // «حالة تطبيق المدرسة»: who installed the school app, notifications on/off, push / WhatsApp to them
      path: '/app-status',
      name: 'app-status',
      component: () => import('@/views/app-status.vue')
    },
    {
      path: '/app-tutorials',
      name: 'app-tutorials',
      component: () => import('@/views/app-tutorials.vue')
    },
    {
      path: '/app-features',
      name: 'app-features',
      component: () => import('@/views/app-features.vue')
    },
    {
      path: '/request-stats',
      name: 'request-stats',
      component: () => import('@/views/request-stats.vue')
    },
    {
      // «سجل تصحيح الأخطاء»: ?sig=… opens one error (links from «إحصائيات الطلبات»)
      path: '/error-log',
      name: 'error-log',
      component: () => import('@/views/error-log.vue')
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('@/views/orders.vue')
    },
    {
      path: '/freedays',
      name: 'freedays',
      component: () => import('@/views/freedays.vue')
    },
    {
      path: '/services',
      name: 'services',
      component: () => import('@/views/services.vue')
    },
    {
      path: '/todo',
      name: 'todo',
      component: () => import('@/views/resellers_todo.vue')
    },
    {
      path: '/visits',
      name: 'visits',
      component: () => import('@/views/resellers_visits.vue')
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: () => import('@/views/resellers_calendar.vue')
    },
    {
      // «المساعد الذكي»: own side-menu item (navigation/vertical), no section tabs
      path: '/ai-assistant',
      name: 'ai-assistant',
      component: () => import('@/views/ai-assistant.vue')
    },
    {
      // «مركز الاتصالات»: own side-menu item (navigation/vertical), no section tabs
      path: '/callcenter',
      name: 'callcenter',
      component: () => import('@/views/callcenter.vue')
    },
    {
      // «التحكم في سعود» (المساعد الذكي بالذكاء الاصطناعي): own side-menu item (navigation/vertical), no section tabs
      path: '/saud',
      name: 'saud',
      component: () => import('@/views/saud.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/pages/login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('@/views/pages/logout.vue')
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      name: 'error-4042',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
  ]),
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
